"use client";

import { api } from "convex/_generated/api";
import type { Id } from "convex/_generated/dataModel";
import { useQuery } from "convex/react";

const DEFAULT_SHOWCASE_LIMIT = 30;
const MIN_SHOWCASE_ITEMS = 6;

export type ShowcaseGenerationType = "lesson_plan" | "quiz" | "audio" | "test";

export type ShowcaseFullResultRef =
  | { table: "generations"; id: Id<"generations"> }
  | { table: "testGenerations"; id: Id<"testGenerations"> }
  | { table: "audioGenerations"; id: Id<"audioGenerations"> };

export type ShowcaseGeneration = {
  teacherFirstName: string;
  type: ShowcaseGenerationType;
  title: string;
  previewContent: string;
  fullResultRef: ShowcaseFullResultRef;
  createdAt: number;
};

export type ShowcaseGenerationResult = {
  teacherFirstName: string;
  type: ShowcaseGenerationType;
  title: string;
  previewContent: string;
  createdAt: number;
  contentSections: { heading: string; body: string[] }[];
  pdfText: string;
  audioPreviewUrl?: string;
  audioPreviewSeconds?: number;
};

export function useShowcaseGenerations(limit = DEFAULT_SHOWCASE_LIMIT) {
  const generations = useQuery(api.showcaseGenerations.getShowcaseGenerations, {
    limit,
  }) as ShowcaseGeneration[] | undefined;

  return {
    generations: generations ?? [],
    isLoading: generations === undefined,
    shouldShow: Boolean(generations && generations.length >= MIN_SHOWCASE_ITEMS),
  };
}
